import MobileIntroQuestions from './mobile-intro-questions';

export default MobileIntroQuestions;
